// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"47":"ed51b158","322":"89ac2a4e","673":"1dd5e141"}[chunkId] + ".chunk.css";
};